export default __webpack_public_path__ + "static/home-screen-5b866e223c135688732bc6934b29aa04.svg";